---
title: Welcome to Airlock!
lede: Airlock runs coding agents unattended, each on a machine of its own, and lets you review the result before anything reaches your repositories.
order: 1
part: Get started
---

Airlock is a desktop app for running coding agents you are not watching. You write a task, an agent — Claude Code or Codex — works on a copy of your repositories, and you review its diff and merge it yourself.

![The Airlock window](media/window-whole.webp)

### How it works

1. You write a task: what has to be true when it is done.
2. Airlock copies your repositories into a disposable micro-VM, with its own kernel and a network that refuses everything you have not allowed.
3. The agent works until it hands back. You do something else.
4. You read the diff like a pull request, and merge what you want.

Nothing the agent writes touches your working tree until you merge it.

### How to read this manual

If Airlock is new to you, read the first chapters in order: they take you from the download to a merged change. Every chapter after that stands on its own.
